import { render, staticRenderFns } from "./SdsTextField.vue?vue&type=template&id=3e53f64c"
import script from "./SdsTextField.vue?vue&type=script&setup=true&lang=ts"
export * from "./SdsTextField.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports